export default __webpack_public_path__ + "static/media/25t.a5e75b83.jpg";